import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminPriceObservationsRequest, ListAdminPriceObservationsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminPriceObservationApi = createApi({
    reducerPath: "adminPriceObservationApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["AdminPriceObservations"],
    endpoints: builder => ({
        listAdminPriceObservations: builder.query<ListAdminPriceObservationsResponse, ListAdminPriceObservationsRequest>({
            query: body => ({
                url: `priceObservation/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            }),
            providesTags: ["AdminPriceObservations"]
        })
    })
});

export const {
    useListAdminPriceObservationsQuery,
    useLazyListAdminPriceObservationsQuery
} = adminPriceObservationApi;
